import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { Observable } from 'rxjs/Observable';
import { TramApiService } from '../tram-api.service';
import { Article, ArticleType } from '../core/article';
import { State, ResponseResult } from '../core/state';
import { UsingMode } from '../core/review';
import { NewsService } from '../providers/news.service';
import { StorageService } from '../storage.service';
import { ToasterService } from 'angular5-toaster/angular5-toaster';

@Component({
    selector: 'news',
    templateUrl: './news.component.html',
    styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {
    readonly requestLimit = 10;
    UsingMode = UsingMode;
    private articleToRemove: Article;
    articles: Article[] = [];
    state: State;
    mode: UsingMode = UsingMode.Anonymous;
    isLoading: boolean;

    readonly defaultSrc = './assets/news-data/gap.png';

    constructor(
        private router: Router,
        private api: TramApiService,
        private newsService: NewsService,
        private storage: StorageService,
        private toaster: ToasterService) { }

    ngOnInit() {
        this.mode = UsingMode.Anonymous;

        if (this.storage.isSensitiveDataExist.value) {
            this.api
                .getCurrentUser()
                .then(user => {
                    this.mode = user && user.isModerator
                        ? UsingMode.God
                        : UsingMode.Anonymous;
                })
                .catch(error => { });
        }

        this.loadInternal(0).subscribe();
    }

    onDeleteConfirmationClosed(event) {
        if (event && event.needToDelete) {
            const result = this.newsService.remove(this.articleToRemove.id);
            result.subscribe(isRemoved => {
                if (isRemoved) {
                    const index = this.articles.findIndex(a => {
                        return a.id === this.articleToRemove.id;
                    });

                    if (index >= 0) {
                        this.articles.splice(index, 1);
                    }

                    this.toaster.pop('success', null, 'Статья удалена');
                }

                this.articleToRemove = null;
            }, error => {
                this.articleToRemove = null;
                this.toaster.pop('error', null, error);
            });
        }
    }
    markArticleToRemove(article: Article) {
        this.articleToRemove = article;
    }

    truncateTitle(text: string) {
        if (!text) {
            return;
        }

        const maxLength = 50;
        if (text.length > maxLength) {
            text = text.substr(0, maxLength - 3) + '...';
        }

        return text;
    }

    truncate(text: string) {
        if (!text) {
            return;
        }

        const maxLength = 100;
        if (text.length > maxLength) {
            text = text.substr(0, maxLength - 3) + '...';
        }

        return text;
    }

    wrappedGetMoreNews = (offset: number = 0): Observable<State> => {
        return this.loadInternal(offset)
            .map(response => response.state);
    }

    navigate(article: Article) {
        if (!article && this.mode === UsingMode.God) {
            this.router.navigate(['/news/article', { id: 'new' }]);
            return;
        }
        this.router.navigate(['/news/article', { id: article.id }]);
    }

    private loadInternal(offset: number = 0): Observable<ResponseResult<Article[]>> {
        this.isLoading = true;
        return this.getMoreArticles(offset)
            .map(r => {
                this.state = r.state;

                r.data.forEach(a => {
                    this.articles.push(a);
                });

                this.articles = this.articles.sort((first, second) => {
                    if (first.publishDate > second.publishDate) {
                        return -1;
                    } else if (first.publishDate < second.publishDate) {
                        return 1;
                    } else {
                        return 0;
                    }
                });

                this.isLoading = false;

                return r;
            });
    }
    private getMoreArticles(offset: number = 0): Observable<ResponseResult<Article[]>> {
        return this.newsService.get(this.requestLimit, offset);
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/news.component.ts